/**
 * Display formatting only — does not change contract math or BigNumber precision.
 */

export function shortenAddress(addr, lead = 6, trail = 4) {
  if (!addr || typeof addr !== 'string') return '';
  if (addr.length < lead + trail + 2) return addr;
  return `${addr.slice(0, lead)}…${addr.slice(-trail)}`;
}

export function shortenHash(hash, lead = 6, trail = 4) {
  return shortenAddress(hash, lead, trail);
}

/**
 * Format a numeric string/number for UI display.
 * Preserves full value via title attribute when used with formatWithTitle().
 */
export function formatAmount(value, decimals = 4) {
  if (value === null || value === undefined || value === '') return '0';
  const n = typeof value === 'number' ? value : parseFloat(String(value));
  if (!Number.isFinite(n)) return '0';
  return n.toFixed(decimals);
}

export function formatRate(value, decimals = 4) {
  if (value === null || value === undefined || value === '') return '—';
  const n = typeof value === 'number' ? value : parseFloat(String(value));
  if (!Number.isFinite(n) || n === 0) return '—';
  return n.toFixed(decimals);
}

export function formatWithTitle(display, full) {
  return { display, title: full != null ? String(full) : undefined };
}

export function friendlyError(error, fallback = 'Something went wrong.') {
  const msg = (error && (error.message || error.reason)) || String(error || '');
  const lower = msg.toLowerCase();

  if (
    lower.includes('user rejected') ||
    lower.includes('user denied') ||
    lower.includes('rejected the request') ||
    lower.includes('action_rejected')
  ) {
    return 'Transaction rejected.';
  }
  if (lower.includes('no liquidity')) {
    return 'No liquidity available for this pair.';
  }
  if (lower.includes('unsupported') || lower.includes('switch to sepolia')) {
    return 'Switch to Sepolia to use the public demo.';
  }
  if (lower.includes('insufficient funds') || lower.includes('insufficient balance')) {
    return 'Insufficient balance for this transaction.';
  }
  if (lower.includes('network') && lower.includes('changed')) {
    return 'Network changed. Please try again.';
  }

  return fallback;
}
